module.exports = __webpack_public_path__ + "static/media/BadgeSS.b8386da2.svg";